module.exports = __webpack_public_path__ + "static/opensans-bolditalic-webfont-707854f4671b5ce4a4af4f1e3ec34a5a.woff";